import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


type TContactInfo<T={}> = {

    languageVersions: TLanguageVersionList[]|TLanguageVersionDetail[];
    
} & T;


const ContactInfo = ( props:TContactInfo ) => {
    const emailString = metaDataLanguageVersion("emailString", props.languageVersions);
    const addressString = metaDataLanguageVersion("addressString", props.languageVersions);
    const phoneString = metaDataLanguageVersion("phoneString", props.languageVersions);

    const email = metaDataLanguageVersion("email", props?.languageVersions);
    const address = metaDataLanguageVersion("address", props?.languageVersions);
    const phone = metaDataLanguageVersion("phone", props?.languageVersions);

    return (
        <div className="contact-info-area pt-100 pb-70">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6">
                        <div className="contact-info-box">
                        <div className="icon">
                            <i className="pe-7s-mail"></i>
                        </div>
                        <h3>{emailString}</h3>
                        <p>
                            <a href={`mailto:${email}`}>{email}</a>
                        </p>
                        </div>
                    </div>
        
                    <div className="col-lg-4 col-md-6">
                        <div className="contact-info-box">
                        <div className="icon">
                            <i className="pe-7s-map-2"></i>
                        </div>
                        <h3>{addressString}</h3>
                        <p>
                            {address}
                        </p>
                        </div>
                    </div>
        
                    <div className="col-lg-4 col-md-6">
                        <div className="contact-info-box">
                            <div className="icon">
                                <i className="pe-7s-call"></i>
                            </div>
                            <h3>{phoneString}</h3>
                            <p>
                                <a href={`tel:${phone?.trim()?.replace(/[^0-9]/g, "")}`}>{phone}</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactInfo;
